<template lang="pug">
BriqPanel
  h2.mb-S Settings
  // todo: refactor to BriqMultiselect
  ResourceTypeSwitchField.mb-S(
    v-if="enableResourceGroups"
    :value="resource.ResourceType"
    data-test-id="resource-type-picker"
    name="resourceType"
    label="Resource Type"
    :required="true"
    @resourceTypeSelected="resourceTypeSelected"
    :resourceTypes="filteredResourceTypes"
    :disabled="disableTypeSwitch"
    :enableWarningModal="resource.Key !== undefined"
    )
  BriqMultiselect.mb-S(
    v-if="enableResourceGroups && resource.isSubResource()"
    data-test-id="parent-resource-picker"
    required="required"
    label="Parent resource"
    v-model="resource.ParentResourceKey"
    :options="resourceGroups"
    track-by="Key"
    display="Description"
    :disabled="disabled"
    @select="parentResourceSelected"
    @blur="vuelidate.resource.ParentResourceKey.$touch()"
    :error="parentResourceError"
    )
  IntegrationProviderField(
    :disabled="disableIntegrationProvider"
    :value="resource.ExternalType"
    @integrationProviderSelected="v => $emit('integrationProviderSelected', v)"
    :externalTypes="externalTypes"
    )
</template>

<script>
import ResourceTypeSwitchField from './ResourceSettingsPanel/ResourceTypeSwitchField.vue'
import IntegrationProviderField from './ResourceSettingsPanel/IntegrationProviderField.vue'
import { propEq, reject } from 'ramda'
import ResourceType from '@v/inventory/resources/edit/ResourceType.js'

export default {
  name: 'ResourceSettingsPanel',
  components: { IntegrationProviderField, ResourceTypeSwitchField },
  props: {
    resource: { type: Object, required: true },
    externalTypes: Array,
    enableResourceGroups: Boolean,
    resourceTypes: Array,
    resourceGroups: Array,
    disabled: Boolean,
    vuelidate: { type: Object, required: true },
  },
  computed: {
    disableTypeSwitch() {
      return this.disabled || (this.resource.isResourceGroup() && this.resource.Key !== undefined)
    },
    disableIntegrationProvider() {
      return this.disabled || this.resource.isSubResource()
    },
    filteredResourceTypes() {
      if (!this.resource.isResourceGroup() && this.resource.Key !== null) {
        return reject(propEq('ResourceType', ResourceType.ResourceGroup))(this.resourceTypes)
      }
      return this.resourceTypes
    },
    parentResourceError() {
      return (
        (this.vuelidate.resource.ParentResourceKey?.$dirty &&
          this.vuelidate.resource.ParentResourceKey.$invalid &&
          'Please select a parent resource') ||
        null
      )
    },
  },
  methods: {
    resourceTypeSelected(value) {
      this.resource.ResourceType = value
      if (value !== ResourceType.SubResource) this.resource.ParentResourceKey = null
    },
    parentResourceSelected(resource) {
      this.resource.ExternalType = resource.ExternalType
    },
  },
}
</script>

<style scoped lang="stylus"></style>
